import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-529a47f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "options-reveal" }
const _hoisted_2 = {
  key: 0,
  class: "options-reveal_options left"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_5 = {
  key: 1,
  class: "options-reveal_options right"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(": ")

type Side = 'left' | 'right';


import dom from 'quasar/src/utils/dom.js';;
import {
  computed,
  reactive,
  ref,
  watch,
} from 'vue';

const __default__ = { name: 'SlideOption' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  optionsRight: {
    type: Object,
    default: () => {},
  },
  optionsLeft: {
    type: Object,
    default: () => {},
  },
  item: {
    type: Object,
    default: () => {},
  },
  index: {
    type: Number,
    default: () => 0,
  },
},
  emits: ['action', 'setValue', 'selectItem'],
  setup(__props, { expose, emit }) {

const props = __props





const data = reactive({
  opened: false,
  side: '',
});

const style = computed(() => {
  if (data.opened) {
    const visibleLeftOptions = props.optionsLeft.filter((i: any) => !i.color.includes('hidden'));
    const visibleRightOptions = props.optionsRight.filter((i: any) => !i.color.includes('hidden'));
    const optionsLeftAmount = visibleLeftOptions.length * 90;
    const optionsRightAmount = visibleRightOptions.length * 90;
    const transform = `translateX(${data.side === 'right' ? '' : '-'}${data.side === 'right' ? optionsLeftAmount : optionsRightAmount}px)`;
    return `transform: ${transform};`;
  }
  return '';
});

const handler = ({ evt, ...newInfo }) => {
  if (
    (newInfo.direction === 'right' || newInfo.direction === 'left') && !data.side) {
    if (
      (newInfo.direction === 'right' && props.optionsLeft.filter((i: any) => !i.color.includes('hidden')).length)
      || (newInfo.direction === 'left' && props.optionsRight.filter((i: any) => !i.color.includes('hidden')).length)
    ) {
      data.opened = true;
      data.side = newInfo.direction;
    }
  }
  if (
    (newInfo.direction === 'right' && data.side === 'left')
    || (newInfo.direction === 'left' && data.side === 'right')
  ) {
    data.opened = false;
    setTimeout(() => {
      data.side = '';
    }, 400);
  }
  emit('setValue', props.item, props.index);
};

const clickAction = () => {
  emit('selectItem', props.item);
};

const close = () => {
  data.side = '';
  data.opened = false;
};

const callAction = (action: string): void => {
  emit('action', action, props.item);
  data.side = '';
  data.opened = false;
};

const showMenu = (side: Side) => {
  if (data.opened) close();
  data.opened = true;
  data.side = side;
};

expose({
  close, showMenu,
});

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _directive_touch_swipe = _resolveDirective("touch-swipe")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      style: _normalizeStyle(_unref(style)),
      class: "options-reveal_wrapper",
      onClick: clickAction
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 4),
    (data.side === 'right')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.optionsLeft, (option, index) => {
            return (_openBlock(), _createBlock(_component_q_btn, {
              dense: "",
              flat: "",
              square: "",
              size: "sm",
              key: index,
              class: _normalizeClass(option.color),
              icon: option.icon,
              onClick: _withModifiers(($event: any) => (callAction(option.action)), ["stop"])
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(option.label), 1),
                  (option.additional)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                        _hoisted_4,
                        _createElementVNode("b", null, _toDisplayString(option.additional), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 2
            }, 1032, ["class", "icon", "onClick"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (data.side === 'left')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.optionsRight, (option, index) => {
            return (_openBlock(), _createBlock(_component_q_btn, {
              dense: "",
              flat: "",
              square: "",
              size: "sm",
              key: index,
              class: _normalizeClass(option.color),
              icon: option.icon,
              onClick: _withModifiers(($event: any) => (callAction(option.action)), ["stop"])
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(option.label), 1),
                  (option.additional)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                        _hoisted_7,
                        _createElementVNode("b", null, _toDisplayString(option.additional), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 2
            }, 1032, ["class", "icon", "onClick"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ])), [
    [
      _directive_touch_swipe,
      handler,
      void 0,
      {
        mouse: true,
        touch: true,
        left: true,
        right: true
      }
    ]
  ])
}
}

})